import { all, fork, put, takeEvery, delay } from 'redux-saga/effects';
import * as actions from './actions';

const ALERT_TIMEOUT_MS = 7000;

export function* setAlert(action) {
    const { alert } = action.value;
    if (alert.autoClose) {
        yield delay(ALERT_TIMEOUT_MS);
        yield put(actions.removeAlert(alert));
    }
}

export function* watchForSetAlert() {
    yield takeEvery(actions.SET_ALERT, setAlert);
}

export default function* root() {
    yield all([fork(watchForSetAlert)]);
}
